<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Normal__And__Centre_Alignment" id="a__Hlk164772692"><span>For Grandpa, who always believed that West, Mississippi, could thrive and grow.</span></p>
<p class="P_Normal"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0003.vue?f31cb788